var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            "close-on-click-modal": false,
            title: "卖家备注修改",
            visible: _vm.visible,
            width: "710px",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "y-f y-mb-20 y-f-a" },
            [
              _c(
                "el-select",
                {
                  staticClass: "y-mr-10 y-f-1",
                  attrs: {
                    filterable: "",
                    loading: _vm.loadingRemarkData,
                    placeholder: "常用备注选择",
                    clearable: true,
                  },
                  on: { change: _vm.updateRemark },
                  model: {
                    value: _vm.sellerWordsId,
                    callback: function ($$v) {
                      _vm.sellerWordsId = $$v
                    },
                    expression: "sellerWordsId",
                  },
                },
                _vm._l(_vm.remarkData, function (item, key) {
                  return _c(
                    "el-option",
                    {
                      key: item.id,
                      attrs: { label: item.contents, value: item.id },
                    },
                    [
                      _c("div", { staticClass: "y-f y-f-jb" }, [
                        _c(
                          "span",
                          {
                            staticClass: "constyle",
                            attrs: { title: item.contents },
                          },
                          [_vm._v(_vm._s(item.contents))]
                        ),
                        _c(
                          "span",
                          {
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.deleteRemark(_vm.remarkData[key])
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]),
                    ]
                  )
                }),
                1
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "text", size: "mini" },
                  on: {
                    click: function ($event) {
                      return _vm.showRemarkDialog()
                    },
                  },
                },
                [_vm._v("添加常用备注")]
              ),
            ],
            1
          ),
          _c("el-input", {
            attrs: {
              type: "textarea",
              autosize: { minRows: 6, maxRows: 10 },
              maxlength: "200",
              "show-word-limit": "",
              placeholder: "请输入备注，200字以内",
              max: 200,
            },
            model: {
              value: _vm.sellerWordsInput,
              callback: function ($$v) {
                _vm.sellerWordsInput = $$v
              },
              expression: "sellerWordsInput",
            },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveInfo } },
                [_vm._v("保存")]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加备注",
            center: "",
            visible: _vm.remarkdialogFormVisible,
            width: "500px",
            "before-close": _vm.resetRemarkForm,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.remarkdialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "remarkForm", attrs: { model: _vm.remarkForm } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "remark",
                    label: "备注内容",
                    rules: {
                      required: true,
                      message: "请输入备注内容",
                      trigger: "blur",
                    },
                  },
                },
                [
                  _c("el-input", {
                    staticClass: "y-w-320",
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 6, maxRows: 10 },
                      autocomplete: "off",
                      maxlength: "200",
                      "show-word-limit": "",
                    },
                    model: {
                      value: _vm.remarkForm.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.remarkForm, "remark", $$v)
                      },
                      expression: "remarkForm.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.submitRemarkFn },
                },
                [_vm._v("确 定")]
              ),
              _c("el-button", { on: { click: _vm.resetRemarkForm } }, [
                _vm._v("取 消"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }